// UI-wide constants
// TODO: Better place for these?
import App from "app";

App.ENTITIES = {
    STREAM: "STREAM",
    SOURCE: "SOURCE",
    EXTERNALSOURCE: "EXTERNALSOURCE",
    CACHE: "CACHE",
    WINDOW: "WINDOW",
    CQ: "CQ",
    TARGET: "TARGET",
    WACTIONSTORE: "WACTIONSTORE",
    TYPE: "TYPE",
    FLOW: "FLOW",
    PROPERTYTEMPLATE: "PROPERTYTEMPLATE",
    DEPLOYMENTGROUP: "DG",
    APPLICATION: "APPLICATION",
    NAMESPACE: "NAMESPACE",
    VISUALIZATION: "VISUALIZATION",
    WIZARD: "WIZARD"
};

export const PRESERVED_NAMES = {
    OAuth: "OAuth",
    OAuthAutomated: "OAuthAutomated",
    ManualOAuth: "Manual OAuth",
    ClientCredentialOAuth: "Client Credential OAuth",
    azureSas: "Azure SAS",
    keepTargetTableData: "Keep target table data",
    truncateTargetTableData: "Truncate target table data",
    replaceTargetTableData: "Replace target table data",
    ResourceOwnerPasswordCredentialOAuth: "Resource Owner Password Credential OAuth",
    ApiKey: "API Key",
    ApiToken: "API Token",
    ProjectId: "Project ID",
    Db2zOS: "DB2 for z/OS",
    AvroExternalDb2zOS: "Avro External DB2 for z/OS",
    GCPLakehouseRuntimeCatalog: "Google Cloud Lakehouse Runtime Catalog",
    AWS_MSK_IAM: "AWS_MSK_IAM",
    SCRAM_SHA_256: "SCRAM_SHA_256",
    SCRAM_SHA_512: "SCRAM_SHA_512",
    AzurePostgres: "Azure Database for PostgreSQL",
    CloudSqlMySQL: "Cloud SQL for MySQL",
    CloudSqlPostgres: "Cloud SQL for PostgreSQL",
    CloudSqlSQLServer: "Cloud SQL for SQL Server",
    MariaDB: "MariaDB",
    MariaDBXpand: "MariaDB Xpand",
    MemSQL: "SingleStore (MemSQL)",
    MySQL: "MySQL",
    Postgres: "PostgreSQL",
    SQLMX: "SQL/MX",
    SAPHANA: "SAP HANA",
    StandardBigQueryTables: "Standard BigQuery Tables",
    BigLakeIcebergTablesInBigQuery: "BigLake Iceberg Tables In BigQuery",
    MergeTree: "MergeTree",
    ReplacingMergeTree: "ReplacingMergeTree",
    CoalescingMergeTree: "CoalescingMergeTree",
    CollapsingMergeTree: "CollapsingMergeTree",
    SummingMergeTree: "SummingMergeTree",
    AggregatingMergeTree: "AggregatingMergeTree",
    SSL_X509: "SSL X.509"
};
